// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".bundle." + {"7523":"b5f2d841a7378446ec09","9702":"39e8954a2456f8afd388"}[chunkId] + ".css";
};